import React, { Component } from 'react';
import { FormGroup, Row } from 'reactstrap';
import RoomTypeSelect from 'components/RoomTypeSelect';
import Label from 'components/Input/Label';
import { Field, reduxForm } from 'redux-form';
import RenderedCustomInput from 'components/RenderedCustomInput';
import LargestCol from 'components/LargestCol';
import NumberOfGuestsSelect from './NumberOfGuestsSelect';
import { NON_SMOKING, SMOKING } from 'utils/constants';

class RoomForm extends Component {
  renderRoomTypeSelect = ({ input }) => {
    const { property, isHostBooking } = this.props;

    return (
      <RoomTypeSelect
        id="roomType"
        property={property}
        isHostBooking={isHostBooking}
        {...input}
      />
    );
  };

  render() {
    const { initialValues } = this.props;
    const { numberOfGuests } = initialValues;

    return (
      <div>
        <Row>
          <LargestCol sm={12}>
            <FormGroup>
              <Label htmlFor="roomType">Room Type</Label>
              <Field name="roomType" component={this.renderRoomTypeSelect} />
            </FormGroup>
          </LargestCol>
          <LargestCol sm={12} md={6}>
            <FormGroup>
              <Label htmlFor="numberOfGuests"># of Guests</Label>
              <Field
                id="numberOfGuests"
                name="numberOfGuests"
                component={NumberOfGuestsSelect}
                props={{ newValue: numberOfGuests && numberOfGuests.value }}
              />
            </FormGroup>
          </LargestCol>
        </Row>
        <div role="group" aria-labelledby="roomOptionsLabel">
          <Label id="roomOptionsLabel">Room Options</Label>
          <Row className="mt-1 mb-3">
            <LargestCol sm={12}>
              <FormGroup check inline>
                <Field
                  id="smoking"
                  name="smoking"
                  type="radio"
                  label="Smoking"
                  value={SMOKING}
                  component={RenderedCustomInput}
                />
              </FormGroup>
              <FormGroup check inline>
                <Field
                  id="nonsmoking"
                  name="smoking"
                  type="radio"
                  label="Non-Smoking"
                  value={NON_SMOKING}
                  component={RenderedCustomInput}
                />
              </FormGroup>
              <FormGroup check inline>
                <Field
                  id="accessible"
                  name="accessible"
                  type="checkbox"
                  label="Accessible"
                  component={RenderedCustomInput}
                />
              </FormGroup>
            </LargestCol>
          </Row>
        </div>
        <Row className="mt-1 mb-3">
          <LargestCol sm={12}>
            <p>
              <small>
                For COMP hotel bookings, ROOM TYPE PREFERENCE is not guaranteed
                until check in.
              </small>
            </p>
          </LargestCol>
        </Row>
      </div>
    );
  }
}

export default reduxForm({
  form: 'chooseAccommodation'
})(RoomForm);
